import { useState, useEffect, useRef } from 'react'
import TextField from "@mui/material/TextField";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { styled } from '@mui/system';

const TextFieldWithNumpad = (props) => {
    const {
        value,
        setValue,
        onEnter,
        toggleFieldFocus,
        // ⬆ filtering out props that `button` doesn’t know what to do with.
        ...rest
    } = props

    const [numKeypadOpen, setnumKeypadOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);
    //const [localValue, setLocalValue] = useState(props.value);

    const orientationPortrait = (window.innerWidth < window.innerHeight);
    let popoverWidth = orientationPortrait? window.innerWidth * 0.7 : window.innerWidth * 0.18;
    if (!orientationPortrait && popoverWidth > 280) {
        popoverWidth = 280;
    }
    const popoverHeight = popoverWidth;
    const bhgt = (popoverHeight / 4);           // Button height

    //console.log("Screen: w x h: ", window.innerWidth, window.innerHeight);

    let popoverLeftPos = window.innerWidth * 0.15
    if (!orientationPortrait) {
        if (window.innerWidth <= 1200) {
            popoverLeftPos = 24;
        } else {
            const mg = (window.innerWidth - 1200) / 2;
            popoverLeftPos = mg + 24;
            //console.log("Left position popover: ", popoverLeftPos);
        }
    }
    //const popoverBottomPos = window.innerHeight - 150;
    const popoverBottomPos = window.innerHeight;            // For the Slide in
    const backSpace = "<x" 

    //console.log("Popover position left x top: ", popoverLeftPos, popoverBottomPos);

    const textFieldGotFocus = (event) => {
        //console.log("Textfield got focus - show the popover");
        setAnchorEl(event.target);
        setnumKeypadOpen(true);
        toggleFieldFocus(true);
    };
  
    const popoverLostFocus = (event) => {
        //console.log("Popover lost focus.");
        closeAndSumbit();
        toggleFieldFocus(false);
    };

    const closeAndSumbit = () => {
        setAnchorEl(null);
        setnumKeypadOpen(false);
        //setValue(localValue);
    };

    const addNumberToResult = (inputValueStr) => {
        //console.log("Number button pushed", inputValueStr);
        let tmpVal = props.value;
        tmpVal = tmpVal.concat(inputValueStr);
        //setLocalValue(localValue.concat(inputValueStr));    
        setValue(tmpVal);    
    }

    const handleClear = () => {
        //console.log("Clear button pushed");
        setValue("");
        //setLocalValue("")
    }

    const handleEnter = () => {
        //console.log("Enter button pushed");
        closeAndSumbit();
        //onEnter(localValue);
        onEnter(props.value);
        setValue("");
        //setLocalValue("");
        toggleFieldFocus(false);
    }

    const handleBackspace = () => {
        //console.log("Backspace button pushed - LocalValue: ", localValue);
        //let hlpStr = String(localValue);
        let hlpStr = String(props.value);
        if (hlpStr.length > 0) {
            //console.log("LocalValue length gt 0");
            hlpStr = hlpStr.substring(0,hlpStr.length-1)
            //setLocalValue(hlpStr);
            setValue(hlpStr);
        }
    }

    const handleChange = (value) => {
        //setLocalValue(value);
        setValue(value);
    }

    const handleKeyDown = (e) => {
        //console.log(`Key down: ${e.key} (${e.charCode})`);  // With keyDown there is no charCode !
        if (e.key >= "0" && e.key <= "9" ) {
        //if (e.charCode >= 48 && e.charCode <= 57) {
            addNumberToResult(e.key);
        } else if (e.key === "Enter") {
            handleEnter();
        } else if (e.key === "Backspace") {
            handleBackspace();
        }
    }

    // How to use:
    // Use this as a MUI component
    //  Provide from calling component:
    //      required
    //      id="..."
    //      disabled={...}
    //      type="number"
    //      value={...}
    //      setValue={set...}
    //      onEnter={numpadEnter}
    //      toggleFieldFocus={setCapNrHasFocus}
    //      label="..."
    //      sx={...}
    //
    // Create one state variable: const [capNrHasFocus, setCapNrHasFocus] = useState(false);
    // Create one function:
    //   const numpadEnter = (value) => {
    //     setCapnr(value);
    //     setSearching(true);           
    //     lookupActor(value, color);    // Or query
    //   }
    //  
    // Keypad layout:
    // .-----------------.
    // | 1 | 2 | 3 | <x  |
    // |---|---|---|-----|
    // | 4 | 5 | 6 |  e  |
    // |---|---|---|  n  |
    // | 7 | 8 | 9 |  t  |
    // |---|-------|  e  |
    // |Clr|   0   |  r  |
    // '-----------------'

    const PadButton = styled(Button)({
        color: 'black',
        backgroundColor: '#cfcfe1',
        width: '100%',
        fontWeight: '400',
        fontSize: '20px',
        textTransform: 'capitalize',
        borderWidth: 'thin',
        borderRadius: '5px'
    });

    return (
        <span>
        <TextField {...rest}
            id='NumpadtextFieldInternal'
            type="number"
            value={props.value}
            onChange={(e) => handleChange(e.target.value)} 
            showsoftinputonfocus="false"
            onFocus={ (e) => {textFieldGotFocus(e) }}
        />
        <Popover
            id="numKeypad"
            onKeyDown={handleKeyDown}
            open={numKeypadOpen}
            anchorEl={anchorEl}
            anchorReference="anchorPosition"
            onClose={(e) => {popoverLostFocus(e) }}
            anchorPosition={{
                left: popoverLeftPos,
                top: popoverBottomPos,
            }}
            transformOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            PaperProps={{
                style: {
                backgroundColor: 'transparent'
                }
            }}
            elevation={0}
        >
        <Box id='numKeypadContent' width={popoverWidth} height={popoverHeight} >
            <Slide id="numKeypadSlide" direction="up" in={numKeypadOpen} mountOnEnter unmountOnExit onExit={(e) => {popoverLostFocus(e)}} >
                <Grid id='numKeypadTotal' container direction='row' sx={{ backgroundColor: '#cfcfe1'}}>
                    <Grid item id='numKeypadleft' xs={9}>
                        <Grid container id='numKeypadleftContent' columns={9} direction='row' alignItems="stretch">
                            <Grid item xs={3}> <PadButton id='button1' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(1)}}>1</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button2' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(2)}}>2</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button3' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(3)}}>3</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button4' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(4)}}>4</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button5' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(5)}}>5</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button6' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(6)}}>6</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button7' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(7)}}>7</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button8' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(8)}}>8</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='button9' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(9)}}>9</PadButton></Grid>
                            <Grid item xs={3}> <PadButton id='buttonClr' variant="outlined" sx={{height: bhgt }} onClick={handleClear}>Clr</PadButton></Grid>
                            <Grid item xs={6}> <PadButton id='button0' variant="outlined" sx={{height: bhgt }} onClick={() => {addNumberToResult(0)}}>0</PadButton></Grid>
                        </Grid>
                    </Grid>
                    <Grid item id='numKeypadRight' xs={3}>
                        <Grid container id='numKeypadRightContent' direction='column' justifyContent="space-between" alignItems="stretch">
                            <Grid item> <PadButton id='buttonBackspace' fullWidth variant="outlined" sx={{height: bhgt*2 }} onClick={handleBackspace}>{backSpace}</PadButton></Grid>
                            <Grid item> <PadButton id='buttonEnter' fullWidth variant="outlined" sx={{height: bhgt*2 }} onClick={handleEnter}>Ok</PadButton></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Slide>
        </Box>
        </Popover>
        </span>
    );

}
TextFieldWithNumpad.muiName = 'TextField';

export default TextFieldWithNumpad